import { render, staticRenderFns } from "./marketing.vue?vue&type=template&id=2ddcf70e&"
import script from "./marketing.vue?vue&type=script&lang=ts&"
export * from "./marketing.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "marketing.vue"
export default component.exports